import {dateOffsetFromToday, removeTime} from "@/util/date";

export function dateOffset(value, modifiers) {
  const getDateFromValue = value => {
    if (!value) return false;
    const parts = value.split('.');
    if (parts.length !== 3) return false;
    if (parts[2].length !== 4) return false;
    return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
  }

  const dateIsInOffsetRange = (maxOffset, date) => {
    const maxDate = dateOffsetFromToday(maxOffset);
    removeTime(maxDate);
    removeTime(date);
    return date <= maxDate;
  }

  const date = getDateFromValue(value);
  return {
    valid: !value || (date instanceof Date && modifiers && modifiers.length === 1 && dateIsInOffsetRange(parseInt(modifiers[0]), date)),
    errorMessage: 'Das Datum liegt nicht im erlaubten Zeitraum.',
  }
}
